import { render, staticRenderFns } from "./ManageRegion.modal.vue?vue&type=template&id=2967dc41"
import script from "./ManageRegion.modal.vue?vue&type=script&lang=ts"
export * from "./ManageRegion.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageRegion.modal.vue?vue&type=style&index=0&id=2967dc41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports